// -------------------------------------------------------------------------------
// Libraries
// -------------------------------------------------------------------------------
import React from "react";
import { Input, Form } from "antd";

// -------------------------------------------------------------------------------
// Components
// -------------------------------------------------------------------------------

// -------------------------------------------------------------------------------
// Styles
// -------------------------------------------------------------------------------
import StyledFormTextArea from "./styles";

// -------------------------------------------------------------------------------
// Component
// -------------------------------------------------------------------------------
const { TextArea } = Input;

const FormTextArea = ({ name, label, rules, placeholder, rows }) => {
	const noSpacesRules = {
		validator: (_, value) => {
			if (!value) {
				// So it doesn't double validate
				return Promise.resolve();
			}
			return value.trim() ? Promise.resolve() : Promise.reject(new Error("This field is required."));
		},
	};
	const isFieldRequired = rules?.find(({ required }) => required);
	const ourRules = isFieldRequired ? [...rules, noSpacesRules] : rules;
	return (
		<StyledFormTextArea className="sb-form-text-area">
			<Form.Item name={name} label={label} rules={ourRules}>
				<TextArea autoSize rows={rows} placeholder={placeholder} data-id={name} />
			</Form.Item>
		</StyledFormTextArea>
	);
};

export default FormTextArea;

